import React, { useEffect } from 'react'
import './style.css'
import './company.css'
import TopBar from '../../components/general/topbar/TopBar';
import { clientesData } from '../../assets/texts/ListaClientes'
import TextosIncio from '../../assets/texts/TextosInicio.json'
import MapsLocation from '../../assets/images/banners/webps/mapslocation.webp'
import Footer from '../../components/general/footer/Footer';
import { useNavigate } from 'react-router-dom';
import Banner from '../../assets/images/banners/webps/equiposfrio.webp'
import { Helmet } from 'react-helmet';

export default function AboutUs() {

  let navigate = useNavigate();

  const clientesList = clientesData.map((item) => {
      return <a target='_blak' href={item.link} rel='noreferrer'><img key={item.id} src={item.src} alt={"Logo de "+item.nombre}/></a>
  })

  useEffect(() => {
    window.scroll(0,0);
  })

  const metaTags = {
    title: "Nosotros",
    description: "Nicolini Refrigeración es un empresa dedicada a la venta, instalación y reparación de equipos de frío para camiones y utilitarios. Además cuenta con venta de insumos y repuestos para refrigeracion familiar, comercial y del automotor",
    url: "https://www.nicolinirefrigeracion.com.ar/nosotros"
  }

  return (
    <div className='AboutUs'>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />
        
        <meta property="og:site_name" content={metaTags.title} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={Banner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={Banner} />
      </Helmet>

      <TopBar />
      <div className='company-info'>
        <div className='mision'>
            <h2 className='title'>Experiencia</h2>
            <p className='text'>{TextosIncio.nosotros1}</p>
        </div>
        <div className='vision'>
            <h2 className='title'>Conocimiento</h2>
            <p className='text'>{TextosIncio.nosotros2}</p>
        </div>
        <div className='valores'>
            <h2 className='title'>Alcance</h2>
            <p className='text'>{TextosIncio.nosotros3}</p>
        </div>
        <div className='clientes'>
            <h2 className='title'>Algunos de nuestros clientes</h2>
            <div className='clientesGrid'>
                {clientesList}
            </div>
        </div>
        <div className='location'>
            <h2 className='title'>Nuestro Local</h2>
            <div className='locationGrid'>
                <p className='text'>{TextosIncio.ubicacion}</p>
                <a href='https://maps.app.goo.gl/bD3AzLaLRwKjZWUQ7' target='_blank' rel='noreferrer'>
                    <img src={MapsLocation} alt='Imagen de Google Maps con la ubicación de Nicolini Refrigeración' onClick={() => navigate("")} />
                </a>
            </div>   
          </div>
      </div>
      <Footer />
    </div>
  )
}